import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import ButtonRemovePage from '../../../components/Editor/ButtonRemovePage';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			slider: { totalPages },
			pageSelection: { isActive, pages },
			combo: { isCombining },
		},
	} = state;

	return {
		isDisabled: (isActive && (pages.length === 0 || pages.length === totalPages)) || isCombining,
	};
};

export default connect(mapStateToProps)(ButtonRemovePage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonRemovePage/index.tsx